import React from "react";
import { MdPeopleAlt, MdShoppingCart  } from "react-icons/md";
import { IoMdAppstore } from "react-icons/io";
function Last30Days() {
  return (
    <div className="flex flex-col gap-6" >
      <div className="border rounded-t-lg">
        <div>
          <div className="py-3 px-4 flex justify-start items-center ">
            <div className="bg-orange-500 w-12 h-12 rounded flex justify-center items-center text-white">
              <MdPeopleAlt size={25} />
            </div>
            <div className="flex justify-center items-center flex-col">
              <h1 className="text-2xl font-bold text-gray-700 ml--2">
                Clients
              </h1>
              <div className="flex justify-center items-center pl-4 ">
                <span className="text-2xl ml-2">5,299</span>
                <p className="ml-4 mt-4 text-lime-500 text-xs">+28%</p>
              </div>
            </div>
          </div>
        </div>
        <div className="py-2 px-4 bg-gray-50 border border-gray-100">
          <p className="text-orange-400">View all</p>
        </div>
      </div>
      <div className="border rounded-t-lg">
        <div>
          <div className="py-3 px-4 flex justify-start items-center ">
            <div className="bg-orange-500 w-12 h-12 rounded flex justify-center items-center text-white">
              <MdShoppingCart  size={25} />
            </div>
            <div className="flex justify-center items-center flex-col">
              <h1 className="text-2xl font-bold text-gray-700 ml--2">
                Orders
              </h1>
              <div className="flex justify-center items-center pl-4 ">
                <span className="text-2xl ml-2">8,299</span>
                <p className="ml-4 mt-4 text-red-500 text-xs">-18%</p>
              </div>
            </div>
          </div>
        </div>
        <div className="py-2 px-4 bg-gray-50 border border-gray-100">
          <p className="text-orange-400">View all</p>
        </div>
      </div>
      <div className="border rounded-t-lg">
        <div>
          <div className="py-3 px-4 flex justify-start items-center ">
            <div className="bg-orange-500 w-12 h-12 rounded flex justify-center items-center text-white">
              <IoMdAppstore  size={25} />
            </div>
            <div className="flex justify-center items-center flex-col">
              <h1 className="text-2xl font-bold text-gray-700 ">
                Products
              </h1>
              <div className="flex justify-center items-center pl-4 ">
                <span className="text-2xl ml-2">500</span>
                <p className="ml-4 mt-4 text-lime-500 text-xs">+80%</p>
              </div>
            </div>
          </div>
        </div>
        <div className="py-2 px-4 bg-gray-50 border border-gray-100">
          <p className="text-orange-400">View all</p>
        </div>
      </div>
    </div>
  );
}

export default Last30Days;
